export default __webpack_public_path__ + "static/media/vehicle.18fa5352.png";